'use strict';

/**
 * library
 */
import imagesLoaded from 'imagesloaded';
imagesLoaded.makeJQueryPlugin($);

/**
 * module
 */
import { responsive } from './module/_responsive';
import { nav } from './module/_nav';
import { anchor } from './module/_anchor';
import { fitimg } from './module/_fitimg';
import { hover } from './module/_hover';
import { inview } from './module/_inview';
import { click } from './module/_click';
import { tab_language } from './module/_tab_language';

/**
 * main
 */
const main = (() => {
    const $disabled = $('js-disabled');

    /**
     * init
     */
    const init = () => {
        responsive.init();
        nav.init();
        anchor.init();
        fitimg.init();
        hover.init();
        inview.init();
        click.init();
        tab_language.init();

        $disabled.on('click', event => {
            event.preventDefault();
        });
    };

    /**
     * loaded
     */
    const loaded = () => {
        setTimeout(function () {
            $('body').addClass('is-loaded');
        }, 500);
    };

    // public
    return {
        init: init,
        loaded: loaded
    };
})();

$(() => {
    main.init();

    let loaded = 0;
    const images = $('img').length;

    $('body')
        .imagesLoaded()
        .done(instance => {
            main.loaded();
        })
        .fail(() => {
            main.loaded();
        })
        .progress((instance, image) => {
            loaded++;
            const result = ('00' + Math.floor((loaded / images) * 100)).slice(-3);
            setTimeout(() => {
                $('.js-loader-count').text(result);
            }, 400);
        });
});
